<template>
    <div>
        <p v-if="Loading" style="text-align: center;height: 140px;line-height: 140px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
        <div v-if="!Loading" class="block advertising_top_pc">
            <el-carousel height="140px">
            <el-carousel-item  v-for="(item,index) in advertisingLists" :key="item.advertId">
                <a :href="item.advertUrl"  target="_blank" style="display:block;height:140px">
                    <img style="width:100%;height:140px" :src="'https://www.pyxxww.com:29503' + item.imgPath" alt="">
                    <!-- <el-image style="width:100%;height:100px" :src="'http://121.36.11.76:9503' + item.imgPath" lazy></el-image> -->
                </a>
            </el-carousel-item>
            </el-carousel>
        </div>
        <p v-if="Loadingxw" style="text-align: center;height: 110px;line-height: 110px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
        <div v-if="!Loadingxw" class="headlines_nav ">
            <div class="title_nav">
                <span class="title_head">头条</span>
                <span class="title_navs">新闻</span>
            </div>
             <el-carousel height="110px" direction="vertical" :autoplay="true" indicator-position="none">
                <el-carousel-item class="shufflingPic" v-for="(item,index) in shufflingFunList" :key="item.id" @click.native="shufflingPicFun(item)">
                    <p class="shufflingPicTitles">{{item.title}}</p>
                    <!-- <img style="width:100%" :src="item.image_url" alt=""> -->
                    <div class="shufles" v-for="item in absParameterJsonUrl" :key="item.id"> <p v-if="index == item.id" style="text-align:left">{{item.content}}</p> <span>【详情】</span>   </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>
<script>
import {listApi , listDetails ,advertisingList,generateSign} from '@/api/index'
import Bus from '@/Bus'
const advertisingParameter = {
    appInfoId:10,
    pageNo:1,
    pageSize:10
}
const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5d8220fde4b07e4a5f838772",
    userId: "",
    appInfoId: "10"
}

export default {
    data(){
        return {
            Loading:true,
            Loadingxw:true,
            jumpRouting:true,
            shuParameter: Object.assign({}, shufflingParameter),
             shufflingFunList:null,
            shufflingPicture:[],
            absParameterJsonUrl:[],
            //广告
            listParameter: Object.assign({}, advertisingParameter),
            advertisingLists:null,


        }
    },
    created(){
        this.shufflingFun()
        this.advertisingListFun()
    },
    methods:{
        async shufflingFun(){
            const headers = {
        'Sign': generateSign()
      };
            const res = await this.axios.post(listApi,this.shuParameter,{ headers })
            this.shufflingFunList = res.data.data[0].list.splice(0,5)
            this.shufflingFunList.forEach((element,index) => {
                let absPaUrl = {}
                absPaUrl['id'] = index
                let absParameterTop = {
                    type: 1,
                    id: element.id,
                    userId: "",
                    appInfoId: "10"
                }
                this.axios.post(listDetails,absParameterTop,{ headers }).then(res => {
                    absPaUrl['content'] = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                    this.absParameterJsonUrl.push(absPaUrl)
                    this.Loadingxw = false
                })
            });
        },
        shufflingPicFun(type){
            let routeData = this.$router.resolve({ path: '/details', query: {  id: type.id,jsonUrl:type.jsonUrl } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        },
        advertisingListFun(){
            const headers = {
        'Sign': generateSign()
      };
            this.axios.post(advertisingList,this.listParameter,).then(res => {
                this.advertisingLists = res.data.data[0][1]
                this.Loading = false
            })
        }
    }
}
</script>
<style lang="">
.advertising_top_pc{
    padding:20px 0;
}

  .headlines_nav .el-carousel__indicator.is-active button{
     background: rgb(224, 224, 224);
 }
 .headlines_nav .el-carousel__button{
     background:rgb(73, 73, 73)
 }
    .shufles{
        width: 100%;
        position:absolute;
        bottom:30px;
        right:25px;
        text-align: right;
        z-index: 10;
        height:15px;
        font-size:14px;
        font-family:Source Han Sans CN;
        font-weight:400;
        color:rgba(153,153,153,1);
    }
    .shufles span{
        color:#00479D;
    }
    .shufles p {
        float:left;
        display:block;
        background:#fff;
        width:1000px;
        line-height:16px;
        padding-left:30px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .shufflingPicTitles{
        width:100%;
        position:absolute;
        bottom:0;
        top: 12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        text-align: left;
        height:110px;
        color:#1A1919;
        font-size:30px;
        font-family:Source Han Sans CN;
    }
    .shufflingPic{
        cursor:pointer;
    }
   .headlines_nav{
       height:110px;
   }
   .headlines_nav .title_nav{
       float:left;
       width:92px;
       height:90px;
       line-height:90px;
       padding:20px 0 0 18px;
   }
   .headlines_nav .title_nav .title_head{
       width:70px;
       height:35px;
       line-height:35px;
       text-align: center;
       display:block;
       border-radius: 18px 0 0;
       color:#FFFFFF;
       font-size: 16px;
       font-weight: bolder;
       background:#C90304;
   }
   .headlines_nav .title_nav .title_navs{
       width:70px;
       height:35px;
       line-height:35px;
       text-align: center;
       display:block;
       border-radius: 0 0 18px;
       color:#1A1A1A;
       font-size: 16px;
       font-weight: bolder;
       background:#E6E6E6;
   }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/topAdvertising.vue